import React from 'react';
import PropTypes from 'prop-types';
import { Link, utils } from '@resy/ui-kitchen';
import './VenueCard.scss';

const VenueCard = ({
  venue, bookNowLinkText, noBookNowText,
  handleDirTagging,
}) => {
  const { priceRangeToString } = utils;

  const renderCard = () => (
    <>
      <div
        className="GDA__VenueCard--image"
        style={{
          backgroundImage: `url(${venue.image})`,
        }}
      >
        &nbsp;
      </div>
      <h3 className="GDA__VenueCard--name">{venue.name}</h3>
      <p className="GDA__VenueCard--features">
        {venue.cuisine}
        &nbsp;&middot;&nbsp;
        {venue.city_name}
        &nbsp;&middot;&nbsp;
        {priceRangeToString(venue.price_range, venue.currency)}
      </p>
      <p className="GDA__VenueCard--features--mobile">
        {venue.cuisine}
        <br />
        {venue.city_name}
        &nbsp;&middot;&nbsp;
        {priceRangeToString(venue.price_range, venue.currency)}
      </p>
      <p className="GDA__VenueCard--booknowlink">
        {venue.bookNowLink && bookNowLinkText}
        {venue.venue_url && venue.venue_url_text}
      </p>

      {(!venue.bookNowLink && !venue.venue_url) && (
        <p className="GDA__VenueCard--booknowEmpty">
          {noBookNowText}
        </p>
      )}
    </>
  );
  const extraParams = {
    item_name: venue.name,
    action_name: 'Venue Click',
  };

  const renderCardWrapper = () => {
    if (venue.bookNowLink || venue.venue_url) {
      let linkValue = '';
      if (venue.bookNowLink) linkValue = venue.bookNowLink;
      else if (venue.venue_url) linkValue = venue.venue_url;
      return (
        <Link
          href={linkValue}
          target="_blank"
          rel="noopener noreferrer"
          onContextMenu={() => handleDirTagging(extraParams)}
          onClick={() => handleDirTagging(extraParams)}
        >
          {renderCard()}
        </Link>
      );
    }
    return (
      <div>
        {renderCard()}
      </div>
    );
  };

  return (
    <div className="GDA__VenueCard">
      {renderCardWrapper()}
    </div>
  );
};

VenueCard.defaultProps = {
  venue: {},
  bookNowLinkText: '',
  noBookNowText: '',
};

VenueCard.propTypes = {
  venue: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string,
    cuisine: PropTypes.string,
    currency: PropTypes.string,
    city_name: PropTypes.string,
    price: PropTypes.string,
    price_range: PropTypes.number,
    bookNowLink: PropTypes.string,
    venue_url: PropTypes.string,
    venue_url_text: PropTypes.string,
  }),
  bookNowLinkText: PropTypes.string,
  noBookNowText: PropTypes.string,
  handleDirTagging: PropTypes.func.isRequired,
};

export default VenueCard;
